// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// ELPO Design Studio (Open Design) design-system uygulama + saklama.
// Seçilen sistemin swatch'larını CSS değişkenlerine basar → tüm primary renkleri o markaya döner.

export interface DesignSystemChoice {
  readonly id: string;
  readonly title: string;
  readonly swatches: readonly string[];
  readonly surface?: string;
}

const STORAGE_KEY = 'elpo:designSystem:v1';

function isHex(c: unknown): c is string {
  return typeof c === 'string' && /^#?[0-9a-fA-F]{3,8}$/.test(c.trim());
}

// Hex'i biraz koyulaştır (700 tonu için)
function darken(hex: string, amount = 0.12): string {
  let h = hex.replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  const n = parseInt(h.slice(0, 6), 16);
  const r = Math.max(0, Math.round(((n >> 16) & 255) * (1 - amount)));
  const g = Math.max(0, Math.round(((n >> 8) & 255) * (1 - amount)));
  const b = Math.max(0, Math.round((n & 255) * (1 - amount)));
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
}

export function applyDesignSystem(swatches: readonly string[] | undefined): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement.style;
  const valid = (swatches ?? []).filter(isHex).map((c) => (c.startsWith('#') ? c : `#${c}`));
  if (valid.length === 0) {
    root.removeProperty('--color-primary-500');
    root.removeProperty('--color-primary-600');
    root.removeProperty('--color-primary-700');
    root.removeProperty('--primary');
    root.removeProperty('--accent');
    return;
  }
  const primary = valid[0];
  if (!primary) return;
  const lighter = valid[1] ?? primary;
  const accent = valid[2] ?? valid[1] ?? primary;
  root.setProperty('--color-primary-600', primary);
  root.setProperty('--color-primary-500', lighter);
  root.setProperty('--color-primary-700', darken(primary));
  root.setProperty('--primary', primary);
  root.setProperty('--accent', accent);
}

export function saveDesignSystem(choice: DesignSystemChoice | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (choice) localStorage.setItem(STORAGE_KEY, JSON.stringify(choice));
    else localStorage.removeItem(STORAGE_KEY);
  } catch { /* quota — sessizce geç */ }
}

export function loadDesignSystem(): DesignSystemChoice | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as DesignSystemChoice) : null;
  } catch {
    return null;
  }
}

// Uygulama açılışında kayıtlı sistemi uygula (main.tsx çağırır)
export function bootstrapDesignSystem(): void {
  const saved = loadDesignSystem();
  if (saved) applyDesignSystem(saved.swatches);
}
